<template>
  <div>
    <v-tabs class="mb-2">
      <v-tab
        v-for="route in opciones"
        :key="route.name"
        :to="`/controles/equipo${route.url}`"
      >
        <v-icon left>{{ route.icon }}</v-icon>
        {{ route.name }}
      </v-tab>
    </v-tabs>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  data() {
    return {
      opciones: [
        {
          name: "Inversores",
          url: "/inversores",
          icon: "mdi-power-socket-eu",
        },
        {
          name: "Paneles",
          url: "/paneles",
          icon: "mdi-solar-panel",
        },
        {
          name: "Generadores",
          url: "/generadores",
          icon: "mdi-engine",
        },
      ],
    };
  },
};
</script>
